import React from "react";
import './styles/About.scss';
import { Email, GitHub, LinkedIn } from "@mui/icons-material";
import profilepic from "./assets/img_1.JPG";
import config from "../config";

const About = () => {
    return (
        <section id="about" className="about">
            <div className="about__header">
                <div className="about__content">
                    <div className="text">
                        <p className="greeting">Hello there! Welcome to my portfolio.</p>
                        <h1>I'm Harini S</h1>
                        <p className="headline">
                            AI Enthusiast | Backend Developer | DSA Practitioner | Emerging Expert in LLMs & RAG
                        </p>

                        <div className="icons">
                            <a href={config.linkedInUrl} target="_blank" rel="noopener noreferrer">
                                <LinkedIn className="icon" />
                            </a>
                            <a href={config.githubUrl} target="_blank" rel="noopener noreferrer">
                                <GitHub className="icon" />
                            </a>
                            <a href={`mailto:${config.emailAddress}`} target="_blank" rel="noopener noreferrer">
                                <Email className="icon" />
                            </a>
                        </div>

                        <div className="buttons">
                            <a href={config.cvPath} download="Harini-S-CV.pdf" className="btn">Download CV</a>
                            {/* <a href="#contact" className="btn">Contact Me</a> */}
                        </div>

                    </div>
                </div>

                <div className="about__image">
                    <img src={profilepic} alt="Harini S - Profile" />
                </div>
            </div>
        </section>
    );
}

export default About;